"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSecurityTaggedLink = exports.warnIfShouldBeExternal = exports.getRel = exports.getTarget = void 0;

var _react = _interopRequireDefault(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UnsafeUrl = require("./UnsafeUrl");

var _ThrowError = require("./ThrowError");

// Determine the target attr for an <a>, based on the props of the link component.
var getTarget = function getTarget(external, target) {
  if (target !== undefined) {
    return target;
  }

  if (external) {
    return '_blank';
  }

  return undefined;
}; // Determine the rel attr for an <a>, based on the link component's rel prop and the target attr.


exports.getTarget = getTarget;

var getRel = function getRel(rel, computedTarget) {
  if (rel !== undefined) {
    return rel;
  }

  if (computedTarget && computedTarget !== '_self') {
    // See https://mathiasbynens.github.io/rel-noopener/
    return 'noopener noreferrer';
  }

  return undefined;
};

exports.getRel = getRel;

var warnIfShouldBeExternal = function warnIfShouldBeExternal(external, computedTarget, componentName) {
  if (!external && computedTarget && computedTarget !== '_self') {
    _devLogger.default.warn({
      message: componentName + ": External links should include an icon. Use `external={true}`.",
      key: 'Link: should be external'
    });
  }
}; // If the given `href` might be an XSS vector, wrap the given rendered link in <XSSTooltip> and fire
// an error.


exports.warnIfShouldBeExternal = warnIfShouldBeExternal;

var renderSecurityTaggedLink = function renderSecurityTaggedLink(href, renderedLink) {
  if ((0, _UnsafeUrl.isUnsafeUrl)(href)) {
    (0, _ThrowError.throwErrorAsync)(new Error("Detected XSS attempt! href=\"" + href + "\""));
    return _react.default.createElement(_UnsafeUrl.XSSTooltip, null, renderedLink);
  }

  return renderedLink;
};

exports.renderSecurityTaggedLink = renderSecurityTaggedLink;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/utils/Links.js
// module id = 305
// module chunks = 5 6 7